import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      alias: "/reports",
      name: "reports",
      component: () => import("./components/ReportList")
    },
    {
      path: "/reports/:id",
      name: "report-details",
      component: () => import("./components/Report")
    },
    {
      path: "/add",
      name: "add",
      component: () => import("./components/AddReport")
    }
  ]
});
